export const DELIMETER = ".";
export const DISTRIBUTION_SUFFIX = `${DELIMETER}distribution`;
